import React, { useContext, useEffect } from "react";
import MapData from "../../../../../libs/maps/MapData";
import { EButton, EEmpty, EInfoPanel, ESectionDivider, ETable, EVerticalFormSection } from "../../../../../libs/ui";
import useSpotAssessmentResult from "../Hooks/useSpotAssessmentResult";
import { Loader, Skeleton, Text, Accordion } from "@mantine/core";
import { CSVLink } from "react-csv";
import moment from "moment";
import { EPlaceholder } from "../../../../../libs/ui/src/Placeholder/EPlaceholder";
import { ECard } from "../../../../../libs/ui/src/Card/ECard";
import { BiDownload } from "react-icons/bi";
import ColorBaseMap from "../../../../../libs/maps/ColourBaseMap";
import { AssessmentFilterContext } from "../../Components/Hooks/useAssessmentFilter";
export default function SpotAssessmentResult() {
  const {
    isLoading,
    reportLevel,
    isLoadingDownloadReport,
    spotAssessmentResultData,
    spotAssessmentResultData2,
    spotAssessmentResultCSV,
    keysForTableHeader,
    keysForCompetency,
    keysForOrf,
    isORFDataLoading,
    ORFReportData,
    ORFResultResultCSV,
    grade,

    downloadCSVData,
    totalOfData,
    district,
    block,
    cluster,
    school,
    name,
    month
  } = useSpotAssessmentResult();


  let overallAllCompetencyOfAllDistrict =
    spotAssessmentResultData &&
    Math.round(
      spotAssessmentResultData
        .map((item: any) => {
          return item?.OverAllAvg;
        })
        .reduce((all: any, eachSum: any) => {
          if (!isNaN(eachSum)) {
            return all + eachSum;
          }
          return all;
        }, 0) /
        spotAssessmentResultData.map((item: any) => {
          return item?.OverAllAvg;
        })?.length
    );

  // const isOrf = spotAssessmentResultData?.some(
  //   (item: any) =>
  //     item?.Class_Name === `Class ${grade}` &&
  //     item?.subjects?.some((subject: any) =>
  //       subject?.data?.some((insideChild: any) => insideChild?.type === "orf"),
  //     ),
  // );


  return (
    <div className="flex flex-col gap-7">
      {/* Map  */}
      {/* {isLoading ? (
        <Skeleton radius={"md"} height={450} />
      ) : spotAssessmentResultData ? (
        <div className="w- h-full flex justify-center">
          <div className="w-1/2">
            <ColorBaseMap
              mapData={
                // spotAssessmentResultData
                //   ? Object.keys(spotAssessmentResultData).map((each) => {
                //       const competencyCount = spotAssessmentResultData?.[
                //         each
                //       ]?.filter((e: any) => e?.type !== "orf")?.length;
                //       return {
                //         name:
                //           spotAssessmentResultData?.[each][0]?.District_Name ??
                //           spotAssessmentResultData?.[each][0]?.Block_Name ??
                //           reportLevel?.blockName,
                //         value:
                //           Math.round(
                //             spotAssessmentResultData?.[each]
                //               ?.filter((e: any) => e?.type !== "orf")
                //               .reduce((sum: any, e: any) => {
                //                 const value = e?.Mastery_Status_Percentage;
                //                 if (!isNaN(value)) {
                //                   return sum + value;
                //                 }
                //                 return sum;
                //               }, 0) / competencyCount
                //           ) || 0,
                //       };
                //     })
                //   : []
                spotAssessmentResultData
                  ? spotAssessmentResultData.map((item: any) => {
                      return {
                        name: item?.name,
                        value: item?.OverAllAvg,
                      };
                    })
                  : []
              }
              selectedDistrict={reportLevel?.districtName || ""}
              reportLevel={reportLevel}
              overAllStats={{
                label: "",
                value: overallAllCompetencyOfAllDistrict ?? 100,
                // value: 100,
              }}
              uniqueId={"teacherObservation"}
              hideChart
            />
          </div>
        </div>
      ) : (
        // <MapData
        //   title="District-level choropleth map"
        //   data={spotAssessmentMapData ? Object.keys(spotAssessmentMapData).map(
        //     (each) => ({
        //       district: spotAssessmentMapData?.[each][0]?.District_Name ?? "",
        //       average: spotAssessmentMapData?.[each][0]?.Mastery_Status_Percentage
        //     })) : []}
        //   isLoading={isMapLoading}
        //   setSelectedDistrict={() => { }}
        // />
        <EPlaceholder
          iconSrc={
            require("../../../../../assets/icons/icon-placeholder.svg").default
          }
          title="Create Report"
          description="Please select a month and other filters and press search to generate a report."
        />
      )}
      <div></div> */}
      {/* Table to displayed */}
      <div>
        {isLoading ? (
          <Skeleton radius={"md"} height={250} />
        ) : spotAssessmentResultData?.length > 0 ? (
          <ECard
            title="Filter-wise % students"
            customClass="overflow-auto"
            header={
              <CSVLink
                style={{}}
                className="text-blue-600 text-sm hover:underline"
                data={downloadCSVData ?? []}
                filename={`Spot_Assessment_Result_${month}-${moment().format("YYYY")}.csv`}
              >
                <EButton className="btn-blue">
                  Download Report <BiDownload className="ml-2" size={22} />
                </EButton>
              </CSVLink>
            }
          >
            {/* <ESectionDivider title="Filter-wise % students" /> */}
            <div className="overflow-x-auto">
              <ETable extraClassname="table-fixed">
                <thead>
                  <tr>
                    <th className="max-w-[10px] !p-2 " rowSpan={2}>
                      {name}
                    </th>
                    <th className="max-w-[10px] !p-2 " rowSpan={2}>
                      Overall Avg (%)
                    </th>
                    {spotAssessmentResultData[0]?.subjects?.map(
                      (subject: any, sIndex: any) => (
                        <th className="!p-2 " colSpan={subject?.data?.length}>
                          {subject.subject}
                        </th>
                      ),
                    )}
                  </tr>
                  <tr>
                    {spotAssessmentResultData[0]?.subjects?.map(
                      (subject: any, sIndex: any) =>
                        subject?.data?.map((child: any, dIndex: any) => (
                          <th className="max-w-[50px] !p-2 ">
                            {child?.type == "compentancy"
                              ? child?.Text
                              : `(ORF)`}
                          </th>
                        )),
                    )}
                  </tr>
                </thead>
                <tbody>
                  {spotAssessmentResultData?.map(
                    (district: any, districtIndex: any) => (
                      <tr
                        style={{
                          backgroundColor: `${
                            district?.OverAllAvg > 80
                              ? "#83c6a6"
                              : district?.OverAllAvg > 60 &&
                                  district?.OverAllAvg <= 80
                                ? "#D9EAD3"
                                : district?.OverAllAvg > 40 &&
                                    district?.OverAllAvg <= 60
                                  ? "#FCE5CD"
                                  : district?.OverAllAvg > 20 &&
                                      district?.OverAllAvg <= 40
                                    ? "#F4CCCC"
                                    : "#E06666"
                          }`,
                        }}
                      >
                        <td>{district?.name}</td>
                        <td>{`${district?.OverAllAvg}%`}</td>
                        {district?.subjects?.map((subject: any, sIndex: any) =>
                          subject?.data?.map((detail: any, dIndex: any) => (
                            <>
                              <td>
                                {detail?.AvgPercentage != null
                                  ? detail?.AvgPercentage
                                  : "--"}
                              </td>
                            </>
                          )),
                        )}
                      </tr>
                    ),
                  )}
                  <tr
                    style={{
                      backgroundColor: `${
                        totalOfData?.OverAllAvg > 80
                          ? "#83c6a6"
                          : totalOfData?.OverAllAvg > 60 &&
                              totalOfData?.OverAllAvg <= 80
                            ? "#D9EAD3"
                            : totalOfData?.OverAllAvg > 40 &&
                                totalOfData?.OverAllAvg <= 60
                              ? "#FCE5CD"
                              : totalOfData?.OverAllAvg > 20 &&
                                  totalOfData?.OverAllAvg <= 40
                                ? "#F4CCCC"
                                : "#E06666"
                      }`,
                    }}
                  >
                    <td>{totalOfData?.name}</td>
                    <td>{`${totalOfData?.OverAllAvg}%`}</td>
                  </tr>
                </tbody>
              </ETable>
            </div>
          </ECard>
        ) : (
          <>
            <EPlaceholder
              iconSrc={
                require("../../../../../assets/icons/icon-placeholder.svg")
                  .default
              }
              title="No Data Found"
              description="No records match your selected filters."
            />
          </>
        )}
      </div>

      {/* ORF REPORT */}
      {isORFDataLoading ? (
        <Skeleton radius="md" height={150} />
      ) : grade != 1 &&
        ORFResultResultCSV?.content?.length &&
        ORFResultResultCSV?.content?.length > 0 ? (
        <EInfoPanel
          title="ORF Report"
          // text="This report is generate for all grades and does not rely on the selected grade"
          text="This report is generate for the selected grade"
        >
          <CSVLink
            className="text-blue-600 text-sm hover:underline"
            data={ORFResultResultCSV?.content ?? []}
            headers={ORFResultResultCSV?.headers ?? []}
            filename={`ORF_Result_${moment().format("MMM")}-${moment().format(
              "YYYY",
            )}.csv`}
          >
            {ORFReportData.length ? (
              <EButton className="btn-blue">
                Download Report <BiDownload className="ml-2" size={22} />
              </EButton>
            ) : (
              <Text>
                Please select a month and press search to generate a report!
              </Text>
            )}
          </CSVLink>
        </EInfoPanel>
      ) : null}
    </div>
  );
};

